<script>
import axios from "axios";
import AppSearchSelector from "./AppSearchSelector.vue";
import despachosService from "../../services/despachos.service.js";

export default {
  components: {
    AppSearchSelector,
  },
  props: {
    documentos: Object,
    tipo: String,
    postDocumento: Function,
    cancelar: Function,
    despacho: Object,
  },
  computed: {
    tipo_despacho() {
      return this.tipo;
    },
    isErrors() {
      return this.isError || this.isOCRrror;
    },
  },
  data() {
    return {
      file: null,
      files: [],
      tipo_documento: "",
      fecha_recepcion: "",
      ///BL
      statusBl: "",

      //DIN
      fecha_aceptacion: "",
      tipo_inspeccion_aforo: "",
      subtipo: "",
      numero_manifiesto: "",

      //documento transporte
      tipo_transporte: "",
      numero_documento: "",

      // VB
      tipoDocumentoTransporte: "",
      tipoDocumentoVB: false,
      showConsultaUyD: false,
      requiereUyD: false,

      //tipos vistos buenos
      tipo_vistos_buenos: "",
      vb_n_solicitud: "",
      estado: "",

      //tipos vistos buenos
      numero_guia_despacho: "",

      //1er dus
      fecha_presentacion_primer_dus: "",
      hora_presentacion_primer_dus: "",
      numero_primer_dus: "",
      orden_alerta: "",

      //dus legalizado
      fecha_dus_legalizado: "",

      //documento otro
      nombre_documento: "",

      documentTypes: [],
      documentTypesFiltered: [],

      tipoDocumentoBl: false,

      // Uso y disposición
      numero_solicitud: undefined,
      fecha_aprobacion: undefined,

      tipos_inspeccion_aforo: [],

      errors: [],

      isFetching: undefined,
      isError: undefined,

      isOCRPending: undefined,
      isOCRrror: undefined,
    };
  },
  watch: {
    file: function (e) {
      this.$refs["file-input"].files.forEach((el) => {
        this.files.push(el);
      });
      this.$refs["file-input"].reset();
    },
    tipo_despacho: function () {
      if (this.tipo_despacho != undefined) this.fetchDocumentTypes();
    },
    tipoDocumentoTransporte: async function (newValue) {
      switch (newValue) {
        case "Comprobante seleccion aforo":
        case "DIN":
          await this.fetchTiposInspeccion();
          break;
      }
    },
    isErrors: function (newValue) {
      if (newValue == true) {
        this.$swal({
          icon: "error",
          title: "Error",
          text: this.errors.join("\n\n*"),
        });
      }
    },
  },
  methods: {
    changeTipoDocumento(nuevoTipo) {
      if (nuevoTipo == 1) this.tipoDocumentoTransporte = "Documento_Transporte";
      else if (nuevoTipo == 2) this.tipoDocumentoTransporte = "Vistos_Buenos";
      else if (nuevoTipo == 3) this.tipoDocumentoTransporte = "BL Corregido";
      else if (nuevoTipo == 4) this.tipoDocumentoTransporte = "DIN";
      else if (nuevoTipo == 10) this.tipoDocumentoTransporte = "Guia_Despacho";
      else if (nuevoTipo == 17) this.tipoDocumentoTransporte = "1er_Dus";
      else if (nuevoTipo == 18) this.tipoDocumentoTransporte = "Dus_legalizado";
      else if (nuevoTipo == 20) this.tipoDocumentoTransporte = "Otro";
      else if (nuevoTipo == 30) this.tipoDocumentoTransporte = "Comprobante seleccion aforo";
      else if (nuevoTipo == 35) this.tipoDocumentoTransporte = "Uso_y_disposicion";
      else this.tipoDocumentoTransporte = "";
    },
    changeTipoDocumentoTransporte(nuevoTipoDocumentoTransporte) {
      if (nuevoTipoDocumentoTransporte == 1) this.tipoDocumentoBl = true;
      else this.tipoDocumentoBl = false;
    },
    async eliminar(file) {
      let variable = await this.$swal({
        title: "¿Deseas eliminar este documento?",
        text: "¿Está seguro? ¡No podrás revertir esta acción!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, Borrar!",
        cancelButtonText: "No, cancelar!",
        buttonsStyling: true,
      });
      if (variable.isConfirmed == true) {
        let encontro = false;
        this.files = this.files.filter((el) => {
          if (!encontro) {
            if (el.name == file.name) {
              encontro = true;
            } else {
              return el;
            }
          } else {
            return el;
          }
        });
      }
    },
    async submit() {
      let formData = new FormData();

      this.id = this.$route.params.despachoId;
      formData.append("despachos_id", this.id);
      formData.append(
        "fecha_recepcion",
        new Date().toISOString().slice(0, 19).replace("T", " ")
      );
      formData.append("tipo_documentos_id", this.tipo_documento);

      for (var i = 0; i < this.files.length; i++) {
        let file = this.files[i];
        formData.append("files[" + i + "]", file);
      }

      switch (this.tipoDocumentoTransporte) {
        case "Documento_Transporte":
          formData.append("tipo_transporte", this.tipo_transporte);
          formData.append("numero_documento", this.numero_documento);
          this.tipoDocumentoTransporte = "Documento_Transporte";
          break;

        case "Vistos_Buenos":
          formData.append("tipo_vistos_buenos", this.tipo_vistos_buenos);
          formData.append("numero_solicitud", this.vb_n_solicitud);
          formData.append("estado", this.estado);
          formData.append("requiere_uyd", this.requiereUyD ? 1 : 0);
          this.tipoDocumentoTransporte = "Vistos_Buenos";
          break;

        case "BL Corregido":
          formData.append("status", this.statusBl);
          this.tipoDocumentoTransporte = "BL Corregido";
          break;

        case "DIN":
          formData.append("fecha_aceptacion", this.fecha_aceptacion);

          if (
            this.tipo_inspeccion_aforo != undefined ||
            this.tipo_inspeccion_aforo.trim() != ""
          ) {
            formData.append(
              "tipo_inspeccion_aforo",
              this.tipo_inspeccion_aforo
            );
            formData.append("subtipo", this.subtipo);
            formData.append("numero_manifiesto", this.numero_manifiesto);
          }
          this.tipoDocumentoTransporte = "DIN";
          break;

        case "Guia_Despacho":
          formData.append("numero_guia_despacho", this.numero_guia_despacho);
          this.tipoDocumentoTransporte = "Guia_Despacho";
          break;

        case "1er_Dus":
          formData.append(
            "fecha_presentacion",
            this.fecha_presentacion_primer_dus
          );
          formData.append(
            "hora_presentacion",
            this.hora_presentacion_primer_dus
          );
          formData.append("numero_dus", this.numero_primer_dus);
          formData.append("orden_alerta", this.orden_alerta);

          this.tipoDocumentoTransporte = "1er_Dus";
          break;

        case "Dus_legalizado":
          formData.append("fecha_dus_legalizado", this.fecha_dus_legalizado);
          this.tipoDocumentoTransporte = "Dus_legalizado";
          break;

        case "Otro":
          formData.append("nombre_documento", this.nombre_documento);
          this.tipoDocumentoTransporte = "Otro";
          break;
        case "Comprobante seleccion aforo":
          if (
            this.tipo_inspeccion_aforo != undefined ||
            this.tipo_inspeccion_aforo.trim() != ""
          ) {
            formData.append(
              "tipo_inspeccion_aforo",
              this.tipo_inspeccion_aforo
            );
          }
          this.tipoDocumentoTransporte = "Comprobante seleccion aforo";
          break;
        case "Uso_y_disposicion":
          formData.append("numero_solicitud", this.numero_solicitud);
          formData.append("estado", this.estado);
          formData.append("fecha_aprobacion", this.fecha_aprobacion);
          this.tipoDocumentoTransporte = "Uso_y_disposicion";
          break;
      }

      if (this.tipo_documento == 0) {
        this.$swal({
          icon: "warning",
          title: "",
          text: "Se debe seleccionar un Tipo de documento",
        });
      }
      if (this.files.length > 0) {
        this.cancelar();
        this.postDocumento(formData);
        this.tipo_documento = "";
        this.tipoDocumentoTransporte = "";
        this.fecha_recepcion = "";
        this.files = [];
      } else {
        this.$swal({
          icon: "warning",
          title: "",
          text: "Se deben subir documentos para su comprobación",
        });
      }
    },
    async fetchDocumentTypes(searchQuery = undefined) {
      let query = {
        params: {
          get: '["tipos_documentos"]',
          type: `["${this.tipo_despacho}", "ambos"]`,
          codigo_despacho: this.despacho?.codigo,
        },
      };

      if (searchQuery) {
        query.params.search = searchQuery;
      }

      const { data } = await axios.get(`api/list`, query);

      if (data?.data?.tipos_documentos) {
        this.documentTypes = [...data.data.tipos_documentos];
        this.documentTypesFiltered = [...data.data.tipos_documentos];
      }
    },
    async searchDocumentTypes(searchQuery = undefined) {
      if (searchQuery && this.documentTypes.length > 0) {
        this.documentTypesFiltered = this.documentTypes.filter((item) =>
          item.key.toUpperCase().includes(searchQuery.toUpperCase())
        );
      }
    },
    async fetchTiposInspeccion() {
      this.isFetching = true;
      try {
        const query = {
          params: {
            get: '["tipos_inspeccion"]',
          },
        };
        const { data } = await axios.get(`/api/list`, query);

        if (data?.data?.tipos_inspeccion) {
          this.tipos_inspeccion_aforo = [...data.data.tipos_inspeccion];
        }
        this.isFetching = false;
        this.isError = false;
      } catch (e) {
        this.isFetching = false;
        this.isError = true;
        console.error(e);
        this.errors.push(
          "Hubo un error al obtener los tipos de inspección de aforo"
        );
      }
    },
    async requestOCR(files) {
      this.isOCRPending = true;

      try {
        const formData = new FormData();
        if (files[0]) formData.append("file", files[0]);

        const { data } = await despachosService.requestOCR(formData);

        const ocrData = data?.data;

        if (ocrData?.tipo_inspeccion_id !== undefined && ocrData?.tipo_inspeccion_id !== null) {
             this.tipo_inspeccion_aforo = ocrData.tipo_inspeccion_id;
        }

        this.fecha_aceptacion = data?.data.fecha_aceptacion ?? "";
        this.subtipo = data?.data.codigo_operacion ?? "";
        this.numero_manifiesto = data?.data.numero_manifiesto ?? "0000";

        this.isOCRPending = false;
      } catch (e) {
        this.isOCRError = true;
        console.error(e);
        this.errors.push("Hubo un error al realizar el OCR del documento");
        this.isOCRPending = false;
      }
    },

    preSubmit() {
      if (this.tipoDocumentoTransporte === 'Vistos_Buenos') {
        this.showConsultaUyD = true;
      } else {
        this.submit();
      }
    },

    handleUyDSelection(valor) {
      this.requiereUyD = valor;
      this.showConsultaUyD = false;
      
      this.$nextTick(() => {
        this.submit();
      });
    },
  },
};
</script>

<template>
  <form
    class="flex flex-col gap-4 text-left"
    @submit.prevent="preSubmit"
    id="form-documentos"
    enctype="multipart/form-data"
  >
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-12">
      <div>
        <label>Tipo de documento</label>
        <AppSearchSelector
          id="documento-select"
          name="tipo_documento"
          :selected-value="tipo_documento"
          :options="documentTypesFiltered"
          @refetch-options="(searchQuery) => searchDocumentTypes(searchQuery)"
          @change="
            (value) => {
              tipo_documento = value;
              changeTipoDocumento(value);
            }
          "
          placeholder="Seleccionar un Documento"
        />
      </div>
      <div>
        <div>
          <label>Adjuntar documento</label>
          <b-form-file
            browse-text="ADJUNTAR"
            placeholder="Seleccione un archivo"
            drop-placeholder="Coloque el archivo aquí..."
            accept="application/pdf, image/jpeg, image/png, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            v-model="file"
            ref="file-input"
            multiple
            @change="
              (event) => {
                if (tipoDocumentoTransporte == 'DIN') {
                  requestOCR(event.target.files);
                }
              }
            "
          ></b-form-file>
        </div>

        <div class="flex flex-row flex-wrap gap-1">
          <button
            class="btn-archivo"
            v-b-tooltip.hover
            :title="file.name"
            type="button"
            v-for="(file, index) in files"
            :key="index"
            @click="eliminar(file)"
          >
            <inline-svg
              v-if="file.name.split('.').at(-1) == 'pdf'"
              src="../../assets/images/archivo-pdf.svg"
            />
            <inline-svg
              v-if="
                file.name.split('.').at(-1) == 'png' ||
                file.name.split('.').at(-1) == 'jpg' ||
                file.name.split('.').at(-1) == 'jpeg'
              "
              src="../../assets/images/archivo-png.svg"
            />
            <inline-svg
              v-if="
                file.name.split('.').at(-1) == 'xlsx' ||
                file.name.split('.').at(-1) == 'xls'
              "
              src="../../assets/images/732220.svg"
            />
          </button>
        </div>
      </div>
    </div>

    <!-- Documento_Transporte -->
    <div
      class="grid grid-cols-2 sm:grid-cols-3 gap-12"
      v-if="tipoDocumentoTransporte == 'Documento_Transporte'"
    >
      <div>
        <label>Tipo de documento de transporte</label>
        <select
          id="docuento-select"
          v-model="tipo_transporte"
          @change="changeTipoDocumentoTransporte(tipo_transporte)"
          required
        >
          <option value="" disabled>
            Seleccione el Tipo de documento de transporte
          </option>
          <option
            v-for="(tipoDocTrans, index) in documentos.documento_transporte"
            :key="index"
            :value="tipoDocTrans"
          >
            {{ tipoDocTrans }}
          </option>
        </select>
      </div>

      <div>
        <label>Número de documento de transporte</label>
        <input max="100" v-model="numero_documento" required />
      </div>
    </div>

    <!-- Guia_Despacho -->
    <div
      class="grid grid-cols-2 sm:grid-cols-3"
      v-if="tipoDocumentoTransporte == 'Guia_Despacho'"
    >
      <div>
        <label>Numero Guía Despacho</label>
        <input v-model="numero_guia_despacho" required />
      </div>
    </div>

    <!-- Vistos_Buenos -->
    <div
      class="grid grid-cols-2 sm:grid-cols-3 gap-12"
      v-if="tipoDocumentoTransporte == 'Vistos_Buenos'"
    >
      <div>
        <label>Tipo de VB</label>
        <select id="docuento-select" v-model="tipo_vistos_buenos" required>
          <option value="" selected disabled>Selecciona un tipo de vistos buenos</option>
          <option
            v-for="(tipo, index) in documentos.tipos_vistos_buenos"
            :key="index"
            :value="tipo"
          >
            {{ tipo }}
          </option>
        </select>
      </div>

      <div>
        <label>N° Solicitud</label>
        <input v-model="vb_n_solicitud" required />
      </div>

      <div>
        <label>Estado</label>
        <select v-model="estado" required>
          <option value="" selected disabled>Selecciona un estado</option>
          <option value="Pendiente">Pendiente</option>
          <option value="Aprobado">Aprobado</option>
          <option value="Inmovilizado">Inmovilizado</option>
          <option value="Pendiente de Inspección">
            Pendiente de Inspección
          </option>
          <option value="Presentado">Presentado</option>
          <option value="Rechazado">Rechazado</option>
        </select>
      </div>
    </div>

    <!-- DIN -->
    <div
      class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-12"
      v-if="tipoDocumentoTransporte == 'DIN'"
    >
      <div>
        <label>Fecha Aceptación</label>
        <input type="date" v-model="fecha_aceptacion" required />
      </div>
      <div>
        <label>Tipo de inspección de aforo</label>
        <select v-model="tipo_inspeccion_aforo">
          <option
            v-for="(tipo, i) in tipos_inspeccion_aforo"
            :key="i"
            :value="tipo.value"
          >
            {{ tipo.key }}
          </option>
        </select>
      </div>
    </div>

    <!-- Comprobante seleccion aforo -->
    <div
      class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-12"
      v-if="tipoDocumentoTransporte == 'Comprobante seleccion aforo'"
    >
      <div>
        <label>Tipo de inspección de aforo</label>
        <select v-model="tipo_inspeccion_aforo">
          <option
            v-for="(tipo, i) in tipos_inspeccion_aforo"
            :key="i"
            :value="tipo.value"
          >
            {{ tipo.key }}
          </option>
        </select>
      </div>
    </div>

    <!-- BL Corregido -->
    <div
      class="grid grid-cols-2 sm:grid-cols-3"
      v-if="tipoDocumentoTransporte == 'BL Corregido'"
    >
      <div>
        <label>Status BL</label>
        <select id="status-select" v-model="statusBl" required>
          <option value="" disabled>Selecciona el status del BL</option>
          <option
            v-for="(tipo, index) in documentos?.bl?.status"
            :value="tipo"
            :key="index"
          >
            {{ tipo }}
          </option>
        </select>
      </div>
    </div>

    <!-- 1er_Dus' -->
    <div
      class="grid grid-cols-2 sm:grid-cols-3 gap-12"
      v-if="tipoDocumentoTransporte == '1er_Dus'"
    >
      <div>
        <label>Fecha Presentación</label>
        <b-form-datepicker
          label-next-month="Siguiente mes"
          label-next-year="Siguiente año"
          label-current-month="Mes actual"
          label-prev-year="Año anterior"
          label-prev-month="Mes anterior"
          label-prev-decade="Decada anterior"
          label-next-decade="Decada siguiente"
          label-no-date-selected="No hay fecha seleccionada"
          label-help="Usa el cursos para navegar por las fechas"
          v-model="fecha_presentacion_primer_dus"
          class="mb-2"
        ></b-form-datepicker>
      </div>

      <div>
        <label>Hora de Retiro</label>
        <b-form-timepicker
          label-no-time-selected="No hay hora seleccionada"
          label-close-button="Cerrar"
          label-hours="Horas"
          label-minutes="Minutes"
          v-model="hora_presentacion_primer_dus"
          locale="es"
        ></b-form-timepicker>
      </div>

      <div>
        <label>Cantidad de días para alerta</label>
        <input type="number" v-model="orden_alerta" />
      </div>
      <div>
        <label>Número Primer Dus</label>
        <input type="text" v-model="numero_primer_dus" required />
      </div>
    </div>

    <!-- 'Dus_legalizado' -->
    <div
      class="grid grid-cols-2 sm:grid-cols-3"
      v-if="tipoDocumentoTransporte == 'Dus_legalizado'"
    >
      <b-form-datepicker
        label-next-month="Siguiente mes"
        label-next-year="Siguiente año"
        label-current-month="Mes actual"
        label-prev-year="Año anterior"
        label-prev-month="Mes anterior"
        label-prev-decade="Decada anterior"
        label-next-decade="Decada siguiente"
        label-no-date-selected="No hay fecha seleccionada"
        label-help="Usa el cursor para navegar por las fechas"
        v-model="fecha_dus_legalizado"
        class="mb-2"
      ></b-form-datepicker>
    </div>

    <div
      class="grid grid-cols-2 sm:grid-cols-3"
      v-if="tipoDocumentoTransporte == 'Otro'"
    >
      <div>
        <label>Nombre de documento</label>
        <input type="text" v-model="nombre_documento" required />
      </div>
    </div>

    <!-- Uso y dispsoción -->
    <div
      class="grid grid-cols-1 sm:grid-cols-3 gap-12"
      v-if="tipo_documento == 35"
    >
      <div>
        <label>N° de solicitud</label>
        <input type="text" v-model="numero_solicitud" required />
      </div>
      <div>
        <label>Fecha de aprobación</label>
        <b-form-datepicker
          label-next-month="Siguiente mes"
          label-next-year="Siguiente año"
          label-current-month="Mes actual"
          label-prev-year="Año anterior"
          label-prev-month="Mes anterior"
          label-prev-decade="Decada anterior"
          label-next-decade="Decada siguiente"
          label-no-date-selected="No hay fecha seleccionada"
          label-help="Usa el cursor para navegar por las fechas"
          v-model="fecha_aprobacion"
          class="mb-2"
        ></b-form-datepicker>
      </div>
      <div>
        <label>Estado</label>
        <select v-model="estado">
          <option selected value="Pendiente">Pendiente</option>
          <option value="Aprobado">Aprobado</option>
          <option value="Inmovilizado">Inmovilizado</option>
          <option value="Pendiente de Inspección">
            Pendiente de Inspección
          </option>
          <option value="Presentado">Presentado</option>
          <option value="Rechazado">Rechazado</option>
        </select>
      </div>
    </div>

    <div class="flex flex-row justify-end">
      <button class="btn-principal w-56" type="submit">Enviar</button>
    </div>

    <b-modal
      v-model="showConsultaUyD"
      centered
      id="modal-consulta-UyD"
      title="Requiere UyD" 
    >
      <h4 class="mx-3">¿Este Visto Bueno requiere UyD?</h4>
      <template #modal-footer>
      <div class="ml-auto flex flex-row gap-2">
        <button
          @click="handleUyDSelection(true)"
          class="btn-principal"
        >
          Si
        </button>
        <button 
          class="btn-secundario" 
          @click="handleUyDSelection(false)"
        >
          No
        </button>
      </div>
      </template>
    </b-modal>

    <b-modal
      :visible="isOCRPending"
      hide-header
      hide-footer
      no-close-on-backdrop
      centered
    >
      <div class="flex h-48 flex-col items-center gap-4 justify-center">
        <b-spinner class="text-primary" style="width: 3em; height: 3em" />
        <p>Realizando OCR...</p>
      </div>
    </b-modal>
  </form>
</template>
